<template>
  <div class="news_index">
    <HKPage :title="title" :banner="banner">
        <router-view></router-view>
    </HKPage>
  </div>
</template>
    <script>
import banner from "@/assets/news/banner.png";
import HKPage from "@/page/hk/index.vue";

export default {
  components: {
    HKPage,
  },
  data() {
    return {
      title: { cn: "新闻资讯", en: "CONTACT US" },
      banner: banner,
    };
  },
  methods: {},
};
</script>
    
    <style lang="scss" scoped>
.news_index {
  background: #fff;
}
</style>